import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import EntityCommentsChat from "@/common/components/Entity/Chat/View/EntityCommentsChat";
import { AccessoryCheckDto, EntityType } from "@/core/api/generated/v1";

interface Props {
  accessoryCheck: AccessoryCheckDto;
}

export default function CommentsTabContent({ accessoryCheck }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock spacing={2}>
        <EntityCommentsChat
          entityId={accessoryCheck.id!}
          entityType={EntityType.AccessoryCheck}
          entity={accessoryCheck}
        />
      </ViewContentBlock>
    </PageTabContent>
  );
}
